import PropTypes from 'prop-types';
import React from 'react';
import {ListViewRow} from '../../common';
import I18n from '../../../lib/i18n';
import FormatService from '../../../lib/format';
import {formatValue} from '../../../lib/usage-formatters';

const icons = {
  DATA: {name: 'swap-vert'},
  SMS: {name: 'chat', reverse: true},
  VOICE: {name: 'call', reverse: true},
};

function getKey(country) {
  return country === 'Local' ? 'loc' : 'ext';
}

function getUnitUsage(type) {
  switch (type) {
    case 'DATA':
      return 'VOLUME';
    case 'VOICE':
      return 'DURATION';
    default:
      return 'SMS';
  }
}

const UsageListViewRow = props => (
  <ListViewRow
    color="grey"
    endText={FormatService.formatCentsToCurrency(props.amount, true)}
    iconName={icons[props.type].name}
    noBadge
    reverseIcon={icons[props.type].reverse}
    subtitle={props.type === 'DATA' ? '' : props.phoneLine}
    subtitleDetail={
      props.type === 'SMS'
        ? ''
        : formatValue(props.quantity, getUnitUsage(props.type))
    }
    timestamp={props.timestamp}
    title={I18n.t(
      `detailedUsages.${props.type}.${getKey(props.to)}_${getKey(props.from)}`,
      {
        from: I18n.t(`countries.${props.from}`),
        to: I18n.t(`countries.${props.to}`),
      },
    )}
  />
);

UsageListViewRow.propTypes = {
  amount: PropTypes.string.isRequired,
  from: PropTypes.string,
  phoneLine: PropTypes.string,
  quantity: PropTypes.string,
  timestamp: PropTypes.number.isRequired,
  to: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default UsageListViewRow;
